<template>
	<div style="height: 100%;">
		<div class="background1" style="height: 100%;">
			<div class="table" style="padding: 0">
				<div class="treeMes" style="padding: 0 10px 0 10px">
					<div class="chooseBox spaceBetween" style="height: 80px;">
						<div class="selectBox">
							<div>
								<div style="display: flex;align-items: center">
									<p style="margin-right: 20px">{{$t('label_524')}}</p>
									<el-radio v-model="radio" label="1" @change="selLables">{{$t('label_542')}}</el-radio>
									<el-radio v-model="radio" label="2" @change="selLable">{{$t('label_537')}}</el-radio>
									<div v-if="timeChange==1">
										<!-- <el-date-picker v-model="Readytime" value-format="yyyy-MM" type="monthrange" :range-separator="$t('label_264')"
										 start-placeholder="开始月份" end-placeholder="结束月份" unlink-panels style='width:355px;'>
										</el-date-picker> -->
										<el-date-picker v-model="Readytime[0]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
                                    :picker-options="pickerOptions" style='width:120px;'>
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker v-model="Readytime[1]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
                                    :picker-options="pickerOptions" style='width:120px;'>
										</el-date-picker>
									</div>
									<div v-else>
										<!-- <el-date-picker v-model="value1" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetimerange"
										 range-separator="{{$t('label_264')}}" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" unlink-panels style='width:355px;'>
										</el-date-picker> -->
										<el-date-picker v-model="value1[0]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
                                    :picker-options="pickerOptions" style='width:180px;'>
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker v-model="value1[1]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
                                    :picker-options="pickerOptions" style='width:180px;'>
										</el-date-picker>
									</div>
									<div style="display: flex;align-items: center;margin-left: 80px">
										<p style="margin-right: 20px">{{$t('label_670')}}</p>
										<el-radio v-model="radios" label="1" @change="selTimeHours">{{$t('label_74')}}</el-radio>
										<el-radio v-model="radios" label="2" @change="selTimeMinutes">{{$t('label_647')}}</el-radio>
									</div>

								</div>
								<div style="margin-top: 5px;display: flex;align-items: center;">
									<div class="selectChoose">
										<div class="selectTexts" style="width: 70px">
											<p>{{$t('label_501')}}</p>
										</div>
										<el-select v-model="searchData.sortName">
											<el-option :label="$t('label_191')" value="activation">
											</el-option>
											<el-option :label="$t('label_194')" value="code">
											</el-option>
										</el-select>
									</div>
									<div style="display: flex;align-items:center">
										<el-radio v-model="searchData.sort" label="ASC">{{$t('label_526')}}</el-radio>
										<el-radio v-model="searchData.sort" label="DESC">{{$t('label_528')}}</el-radio>
									</div>
<!--                  <div class="selectChoose">-->
<!--                    <div class="selectText">-->
<!--                      <p>设备编号</p>-->
<!--                    </div>-->
<!--                    <div class="select" style="width:350px">-->
<!--                      <el-input v-model="deviceCode" clearable></el-input>-->
<!--                    </div>-->
<!--                  </div>-->
								</div>
							</div>
						</div>
						<div class="buttonBox">
							<div>
								<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
							</div>
						</div>
					</div>
					<div class="spotMes2Box" style="height:calc(100% - 62px)">
						<div class="tableMin" style="height: calc(100% - 70px);">
							<!--button按钮-->
<!--							<div class="buttonBox" style="margin-bottom: 10px;" v-if="MenuRoleList.indexOf('109')>=0">-->
<!--								<div>-->
<!--									<div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-upload2"></i>{{$t('btn_10')}}</div>-->
<!--								</div>-->
<!--							</div>-->
							<el-table :empty-text="$t('label_357')" ref="singleTable" :data="selectPageDayList" highlight-current-row border style="width: 100%;" height="90%"
							 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
								<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
								</el-table-column>
								<el-table-column :label="$t('label_194')" align="left" prop="code">
									<template slot-scope="scope">
										<span style="font-size: 16px;"> {{scope.row.code}} </span>
									</template>
								</el-table-column>
								<el-table-column :label="$t('label_191') + '(%)'" align="left" prop="valid">
									<template slot-scope="scope">
										<span style="font-size: 16px;"> {{(scope.row.activation>100?100:scope.row.activation)}} </span>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" :label="this.radios=='1'?$t('label_198') + '(h)':$t('label_198') + '(' +  $t('label_647') + ')'" align="left">
									<template slot-scope="scope">
										<span style="font-size: 16px;"> {{parseFloat(updatatime(scope.row.loadTime)).toFixed(2)}} </span>
									</template>
								</el-table-column>

								<el-table-column prop="lifeAlarmTime" :label="this.radios=='1'?$t('label_152') + '(h)':$t('label_152') + '(' +  $t('label_647') + ')'" align="left">
									<template slot-scope="scope">
										<span style="font-size: 16px;"> {{parseFloat(updatatime(scope.row.shutdownTime)).toFixed(2)}}
										</span>
									</template>
								</el-table-column>
								<el-table-column :label="$t('label_202')" align="left" prop="num">
								</el-table-column>
							</el-table>
						</div>
					</div>
          <div style="position: absolute;bottom: 10px;left: 30%">
            <Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
                  @parentMethod="searchPage"></Page>
          </div>
					<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"
					 ref="exportBox"></exportMes>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/pageNew2";
	import utils from '@/utils/utils';
	import exportMes from "@/components/list/export/export";
	import signal from "@/assets/js/signal/signal.js";
	import kpi from "@/assets/js/signal/kpi.js";
	import $ from 'jquery'
	export default {
		name: "kpiList",
		components: {
			utils,
			file,
			Page,
			exportMes,
		},
		data() {
			return {
			  pickerOptions: {
          disabledDate(time) {
            return time > Date.now();
          }
        },
				exportTitle: '',
				tableDataTreeTime: [],
				tableDataTreeTimeExport: [],
				pageCount: 1,
				pageSize: 50,
        pageNum: 1,
				selectPageDayList: [],
				selectPageList: [],
				Readytime: '', // 时间月
				value1: [], //时间日
				radio: '1', // 期间
				radiosss: '1', // 单位
				radios: '1',
				timeChange: '1', // 用来判断日期格式
				item: '',
				typeNext: true, // 是否包含当前时间
				exportList: [{
					column: 'code',
					title: this.$t('label_194'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'activation',
					title: this.$t('label_191') + '(' + this.$t('%') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'loadTimeNew',
					title: this.$t('label_198') + '(' + this.$t('label_74') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'shutdownTime',
					title: this.$t('label_152') + '(' + this.$t('label_74') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'num',
					title: this.$t('label_202') + '(' + this.$t('label_207') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}],
				searchData: {

					beginTime: "2022-04-07 08:00:00",
					endTime: "2022-04-09 02:00:00",
					id: 0,
					type: 2,
					next: true,
					sort: "ASC",
					sortName: "activation",
				},
				value: '',
				workTime: {},
				MenuRoleList: [],
        // deviceCode: '',
			}
		},
		methods: {
      getIndex(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
			// 设置默认日期
			defaultDateMonth() {
				//获取新的时间(2019.4.12）
				let date = new Date()
				//获取当前时间的年份转为字符串
				let year = date.getFullYear().toString() //'2019'
				//获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
				let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1)
					.toString() //'04'
				//获取天，判断是否小于10，如果是在字符串前面拼接'0'
				let da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString() //'12'
				//获取时
				let hour = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours().toString()
				//获取分
				let minute = date.getMinutes() < 10 ? '0' + data.getMinutes().toString() : date.getMinutes().toString()
				//获取秒
				let second = date.getSeconds() < 10 ? '0' + data.getSeconds().toString() : date.getSeconds().toString()
				//字符串拼接，开始时间，结束时间
				let end = year + '-' + month + '-' + da + ' ' + hour + ':' + minute
				let beg = year + '-' + month + '-01' + ' ' + '08' + ':' + '00'
				this.value1 = [beg, end] //将值设置给插件绑定的数据
				let end1 = year + '-' + month //当天'2019-04-12'
				let beg1 = year + '-' + month //当月第一天'2019-04-01'
				this.Readytime = [beg1, end1] //将值设置给插件绑定的数据
			},
			updatetime(num) {
				let sdd = new Date(num);
				let yyyy = sdd.getFullYear();
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = (sdd.getHours() + 1) < 10 ? '0' + (sdd.getHours() + 1) : (sdd.getHours() + 1)
				// let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				// let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':00:00'
			},
			// 获取时间
			getTime() {
				var $this = this;
				file.selectTimee().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.value1.push(data.data.beginTime, $this.updatetime(data.data.endTime))
            console.log("getTime" + JSON.stringify(this.value1))
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//获取时间的默认值
			getDate() {
				let start = this.Fungetdate(0) // 7天前
				let end = this.Fungetdate(0) // 当前时间
				this.dateValue.push(start, end)
				this.Readytime = this.dateValue
				this.value1 = this.dateValue
        console.log("getDate" + JSON.stringify(this.value1))
				this.dyTime = this.dateValue //  当前时间
			},
			// 点击单选框 月  1
			selLables(val) {
				this.timeChange = val
				this.initDate();
			},
			// 点击单选框  日 2
			selLable(val) {
				this.timeChange = val
        if (!(utils.isEmpty(this.workTime.beginTime) || utils.isEmpty(this.workTime.endTime))) {
          this.value1 = [this.workTime.beginTime.substring(0, 13) + ':00:00', this.updatetime(this.workTime.endTime)];
        }
			},

			//点击单选框 时
			selTimeHours() {
				this.exportList[2].title = this.$t('label_198') + '(' + this.$t('label_74') + ')'
				this.exportList[3].title = this.$t('label_152') + '(' + this.$t('label_74') + ')'
				this.excle();
			},
			//点击单选框 分
			selTimeMinutes() {
				this.exportList[2].title = this.$t('label_198') + '(' + this.$t('label_647') + ')'
				this.exportList[3].title = this.$t('label_152') + '(' + this.$t('label_647') + ')'
				this.excle();
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},

			changeTime(e) {
				this.$forceUpdate()
			},
			search() {
				if (this.radio == '1') {
          this.searchData.next = false;
					this.searchData.beginTime = this.Readytime[0];
					this.searchData.endTime = this.Readytime[1];
					if (
					  this.Readytime.length < 2
            || new Date().getMonth() + 1 == new Date(this.searchData.endTime).getMonth() + 1
            && new Date().getFullYear() == new Date(this.searchData.endTime).getFullYear()
          ) {
            this.searchData.next = true;
          }
				} else {
					//开始时间
					this.searchData.beginTime = this.value1[0];
					//结束时间
					this.searchData.endTime = this.value1[1];
					this.searchData.next = this.value1.length < 2 || this.searchData.endTime == '' ? true : false;
				}
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			searchPage(param) {
				//请求检索条件
				let dataParam = this.searchData;
				let newParam = Object.assign(param, dataParam);
				// this.$set(newParam, 'code', this.deviceCode);
				if (this.radio == 1) {
					kpi.selectPage(newParam).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.selectPageDayList = data.data.list;
							this.pageNum = data.data.pageNum;
							this.pageSize = data.data.pageSize == 0 ? data.data.size : data.data.pageSize;
							this.pageCount = data.data.total;
							this.$refs['pageModel'].setCurrent(this.pageNum);
							$('.el-table__body-wrapper').animate({
								scrollTop: 0
							}, 400);
							// //定时查询echarts数据
							// that.selectTime(that.selectEquipmentList);
							// utils.clearTime();
						}
					}).catch((response) => {
						console.log(response)
					});
				} else {
					kpi.selectPageDay(newParam).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.selectPageDayList = data.data.list;
							this.pageNum = data.data.pageNum;
							this.pageSize = data.data.pageSize == 0 ? data.data.size : data.data.pageSize;
							this.pageCount = data.data.total;
							this.$refs['pageModel'].setCurrent(this.pageNum);
							$('.el-table__body-wrapper').animate({
								scrollTop: 0
							}, 400);
						}
					}).catch((response) => {
						console.log(response)
					});
				}
				this.selectExcel(newParam);
			},
			// 调用Excle接口
			selectExcel(param) {
				if (this.radio == 1) {
					kpi.selectExcel(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.tableDataTreeTimeExport = data.data;
							this.excle();
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					kpi.selectDayExcel(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.tableDataTreeTimeExport = data.data;
							this.excle();
						}
					}).catch((response) => {
						console.log(response)
					})
				}
			},
			// 循环遍历数组  /3600=时  /60=分 .toFixed()保留小数
			excle() {
				if (this.radios == 1) {
					for (let i = 0; i < this.tableDataTreeTimeExport.length; i++) {
						this.tableDataTreeTimeExport[i].loadTimeNew = (this.tableDataTreeTimeExport[i].loadTime / 3600).toFixed(2)
						this.tableDataTreeTimeExport[i].shutdownTime = (this.tableDataTreeTimeExport[i].shutdownTime / 3600).toFixed(2)
					}
				} else {
					for (let i = 0; i < this.tableDataTreeTimeExport.length; i++) {
						this.tableDataTreeTimeExport[i].loadTimeNew = (this.tableDataTreeTimeExport[i].loadTime / 60).toFixed(2)
						this.tableDataTreeTimeExport[i].shutdownTime = (this.tableDataTreeTimeExport[i].shutdownTime / 60).toFixed(2)
					}
				}
			},
			newMes(data, workTime, code) {
				this.workTime = workTime;
				this.searchData.type = data.type;
				this.searchData.id = data.id;
				// this.deviceCode = code;
				this.initDate();
				this.search();
			},
			//初始化时间
			initDate: function() {
				let date = new Date();
				let seperator = "-";
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				let currentMonth = year + seperator + this.zero(month);
				let currentDay = year + seperator + this.zero(month) + seperator + this.zero(day) + ' 00:00';
				this.Readytime = [currentMonth, currentMonth];

			},
			//补0
			zero: function(i) {
				return i > 9 ? i : '0' + i;
			},
			updatatime(time) {
				if (this.radios == '1') {
					return time / 3600
				} else {
					return time / 60
				}
			}
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			// this.selectPage();
			// this.defaultDateMonth();
			// this.getTime();
			// this.timer = setInterval(() => {
			//   setTimeout(() => {
			//     this.search()
			//   }, 0)
			// }, 5000)
		},

	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/KPI/kpiList.vue